export default __webpack_public_path__ + "static/media/nc.9b755b87.png";